import { useId } from 'react'
import { Props_SnippetGallery } from './Gallery.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'
import VideoComponent from '../Shared/SharedVideo/SharedVideo'

const chunkArray = <T,>(arr: T[], size: number): T[][] =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
        arr.slice(i * size, i * size + size)
    )

const SnippetGallery = (props: Props_SnippetGallery) => {
    const { heading, content, link, repeatable_image } = props

    const uniqueId = useId()
    const classHeadingVisibility: string = heading.visibility?.value ? 'snippet-gallery__heading--visible' : 'snippet-gallery__heading--hidden'
    const hasLink = !!link.linkHref?.value

    return (
        <section className="snippet-gallery">
            <div className="snippet-gallery__container">
                <h2 className={`snippet-gallery__heading ${classHeadingVisibility}`}>
                    {heading.content.value}
                </h2>
                {content.content?.value && (
                    <div className="snippet-gallery__content">
                        {content.content?.value && (
                            <div className="snippet-gallery__paragraph">{CompileMarkdown(content.content.value)}</div>
                        )}
                    </div>
                )}

                {chunkArray(repeatable_image, 4).map((group, groupIndex) => (
                <div key={`snippet-gallery-${uniqueId}-grid-${groupIndex}`} className="snippet-gallery__grid">
                    {group.map(({ src, alt, video_url, audioDescriptionUrl }, index) => {
                        const hasVideo = !!video_url?.value
                        return (
                            <div key={`snippet-gallery-${uniqueId}-item-${groupIndex}-${index}`} className={`snippet-gallery__item`}>
                                {hasVideo ? (
                                    <VideoComponent
                                        snippetClassName="snippet-gallery"
                                        url={video_url.value}
                                        directEmbed={true}
                                        audioDescriptionUrl={audioDescriptionUrl?.value || undefined}
                                    />
                                ) : (
                                    <img
                                        loading="lazy"
                                        src={src.value}
                                        className="snippet-gallery__image"
                                        alt={alt?.value || ''}
                                        width="600"
                                        height="400"
                                    />
                                )}
                            </div>
                        )
                    })}
                </div>
                ))}

                {hasLink && (
                    <div className={`snippet-gallery__button-container snippet-gallery__button-container--${link.alignment?.value || 'center'}`}>
                        <SnippetLink
                            linkStyles={link.linkStyle?.value}
                            className="snippet-gallery__link"
                            url={link.linkHref?.value}
                            openInNewTab={link.linkTarget?.value}
                            aria-label={link.linkAriaLabel?.value || link.linkText?.value}
                        >
                            {link.linkText?.value}
                        </SnippetLink>
                    </div>
                )}
            </div>
        </section>
    )
}

export default SnippetGallery
